import React, { useEffect } from "react";
import { Button } from "@vds/buttons";
import { Box } from "@mui/system";
import "../../styles/deviceStyle.css";

import { useDispatch, useSelector } from "react-redux";
import {
  fetchRequest,
  fetchDeviceTypeRequest,
  updateUI,
  deleteRequest,
  updateFilters,
} from "../../store/actions/deviceProfile";

import {
  fetchRequest as fetchLocationRequest,
  updateUI as updateLocationUI,
} from "../../store/actions/location";
import DeviceProfileList from "./DeviceProfileList";
import CreateDeviceProfile from "./CreateDeviceProfile";

import "./deviceProfile.css";
import ToastNotification from "../../global/components/ToastNotification";
import getSingleDeviceProfile from "./utility/getSingleDeviceProfile";
import { useLocation } from "react-router-dom";
import CreateNewLocation from "../LocationDetails/CreateLocation/new";
import CustomModal from "../../components/CustomModal";
import Grid2 from "@mui/material/Unstable_Grid2/Grid2";
import ValidateDeviceProfileModal from "./ValidateDeviceProfileModal";
import ActiveShipDeleteProfile from "./ActiveShipDeleteProfile";

const DeviceProfile = () => {
  const stateObj = useLocation();
  const { profileId } = stateObj.state || { profileId: "" };
  const dispatch = useDispatch();
  const {
    deviceProfiles,
    shouldUpdate,
    isNotificationActive,
    notification,
    deleteField,
    user,
    formFields,
    form,
    hasActiveShipments
  } = useSelector((state) => ({
    deviceProfiles: state.deviceProfile.data.devices,
    shouldUpdate: state.deviceProfile.shouldUpdate,
    notification: state.deviceProfile.ui.notification,
    isNotificationActive: state.deviceProfile.ui.notification.isActive,
    deleteField: state.deviceProfile.ui.delete,
    user: state.auth.user,
    form: state.deviceProfile.ui.form,
    formFields: state.deviceProfile.ui.form.fields,
    hasActiveShipments:state.deviceProfile.ui,
  }));

  const locationForm = useSelector((state) => state?.location?.ui?.form);

  //const user = useSelector((state) => state.auth.user);

  // useEffect(() => {
  //   if (deviceProfileForm?.type === "" && locationForm?.type === "") {
  //     dispatch(
  //       updateUI({
  //         key: "form",
  //         value: {
  //           type: "create",
  //         },
  //       })
  //     );
  //   }
  // }, [dispatch, locationForm?.type]);

  useEffect(() => {
    let timer1 = null;
    dispatch(fetchRequest());
    dispatch(fetchDeviceTypeRequest());
    if (profileId) {
      const singleDeviceProfile = getSingleDeviceProfile(
        deviceProfiles,
        profileId
      );
      if (singleDeviceProfile === null) return;
      dispatch(
        updateUI({
          key: "form",
          value: {
            type: "view",
            step: -1,
            ...singleDeviceProfile,
          },
        })
      );
    }

    if (isNotificationActive) {
      timer1 = setTimeout(
        () =>
          dispatch(
            updateUI({
              key: "notification",
              value: {
                isActive: false,
              },
            })
          ),
        5000
      );
    }

    return () => {
      if (timer1) {
        clearTimeout(timer1);
      }
    };
  }, [
    dispatch,
    // isNotificationActive,
    shouldUpdate,
    profileId,
    user?.accountId,
  ]);

  useEffect(() => {
    dispatch(
      updateFilters({
        filters: {
          profileNames: [],
          profileTypes: [],
          description: "",
          deviceTypes: [],
          lastUpdatedto: "",
          lastUpdatedfrom: "",
        },
        sort: "desc",
        field: "updatedon",
      })
    );
  }, [dispatch, user?.accountId]);

  const handleAddDeviceProfile = () => {
    dispatch(fetchLocationRequest(-1));
    dispatch(fetchDeviceTypeRequest());
    dispatch(
      updateUI({
        key: "form",
        value: {
          isOpen: true,
          type: "create",
        },
      })
    );
  };

  const handleDeleteProfileOnConfirm = () => {
    dispatch(deleteRequest());
  };

  const handleDeleteProfileOnExitOrClose = () => {
    dispatch(
      updateUI({
        key: "delete",
        value: {
          isOpen: false,
          id: null,
          name: "",
        },
      })
    );
  };

  const handleBackLocationButtonClick = () => { 
    dispatch(
      updateLocationUI({
        key: "form",
        state: {
          ...locationForm,
          type: "",
          single: {
            id: null,
            name: "",
          },
          fields: {
            errors: {},
            pointName: "",
            address: "",
            latitude: "",
            longitude: "",
            radius: 500,
            isAdjustGeofanceOnMap: false,
          },
        },
      })
    );
    dispatch(
      updateUI({
        key: "form",
        value: {
          ...form,
          isOpen: true,
          fields: {
            ...formFields,
            step3: {
              ...formFields.step3,
              locations: formFields.step3.locations.map((location, index) => {
                if (location?.currentLocation === "new") {
                  const requireFields = [
                    "pointName",
                    "address",
                    "latitude",
                    "longitude",
                  ];
                  const hasValue = Object.entries(location?.new)
                    .filter((loc) => requireFields.includes(loc[0]))
                    .some((loc) => loc[1].value);
                  return {
                    ...formFields.step3.locations[index],
                    currentLocation: hasValue ? "existing" : "",
                  };
                }

                return location;
              }),
            },
          },
        },
      })
    );
  };
  const handleShipProfileOnExitOrClose = () => {
     dispatch(updateUI({
          key: "activeShipmentPopup",
          value: {
            isOpen: false,
            type: "",
          }
        }));
  };

  const handleShipProfileOnConfirm = () => {
    const id = hasActiveShipments?.shipValidate?.id;
    dispatch(updateUI({
    key: "activeShipmentPopup",
    value: { isOpen: false, type: "" }
  }));
  dispatch(updateUI({
      key: "shipValidate",
      value: {
        id,
        actionType: "edit",
        proceed: true
      }
    }));
};

  return (
    <div style={{ minHeight: "65vh" }}>
      {notification.isActive && (
        <ToastNotification
          type={notification.type}
          message={notification.message}
          description={notification.description}
          duration={1}
          style={notification.style}
        />
      )}
      <Box sx={{ width: "100%" }}>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <h2 className="page-common-heading_tittle">Device profile</h2>
          <div style={{ alignContent: "end" }}>
            <Button
              onClick={handleAddDeviceProfile}
              style={{
                marginTop: "-42px",
                fontFamily: "VerizonNHGDS",
                fontWeight: 700,
                fontSize: "16px",
                lineHeight: "20px",
                letterSpacing: "0.5px",
                textAlign: "center",
              }}
              size="large"
              use="primary"
            >
              Add device profile
            </Button>
          </div>
        </div>
      </Box>
      <CreateDeviceProfile />
      <DeviceProfileList />
      <CustomModal
        modalKey={"deleteprofile"}
        popupName={""}
        customClass={"deleteAlertGroup"}
        popupTitle={"Delete profile"}
        open={deleteField?.isOpen}
      >
        <>
          <>
            <span>Are you sure you want to delete the profile </span>
            <span
              style={{
                fontWeight: "700",
                fontFamily: "VerizonNHGDSBold",
                fontSize: "16px",
              }}
            >
              {deleteField?.name}
            </span>
            ?{" "}
          </>
          <Grid2
            container
            marginTop={1}
            marginBottom={0}
            spacing={1}
            columns={{ xs: 12 }}
          >
            <Grid2 item xs={12} sm={6} md={6} lg={6}>
              <div className="mb-3">
                <Button
                  className="custom-button-cancel"
                  type="default"
                  shape="round"
                  style={{
                    fontWeight: "bold",
                    width: "100%",
                    backgroundColor: "white",
                    color: "black",
                  }}
                  onClick={() => handleDeleteProfileOnExitOrClose()}
                  size={"large"}
                >
                  No, cancel
                </Button>
              </div>
            </Grid2>
            <Grid2 item xs={12} sm={6} md={6} lg={6}>
              <div className="mb-3">
                <Button
                  className="custom-button-save"
                  type="primary"
                  shape="round"
                  onClick={() => {
                    handleDeleteProfileOnConfirm();
                  }}
                  style={{ fontWeight: "bold", width: "100%" }}
                  size={"large"}
                >
                  Yes, delete
                </Button>
              </div>
            </Grid2>
          </Grid2>
        </>
      </CustomModal>
      <ValidateDeviceProfileModal
        modalKey={"deleteprofile"}
        popupName={""}
        customClass={"deleteAlertGroup"}
        popupTitle={"Edit Device Profile"}
        open={hasActiveShipments?.shipValidate?.actionType==="edit"? hasActiveShipments?.activeShipmentPopup?.isOpen: false}
      >
        <>
          <span>Currently this device profile has one or more active shipments associated with it. </span><br/>
           <span>Are you sure you’d like to edit this profile ? </span>
          <Grid2
            container
            marginTop={2}
            marginBottom={0}
            spacing={1}
            columns={{ xs: 12 }}
          >
            <Grid2 item xs={12} sm={6} md={6} lg={6}>
              <div className="mb-3">
                <Button
                  className="custom-button-cancel"
                  type="default"
                  shape="round"
                  style={{
                    fontWeight: "bold",
                    width: "100%",
                    backgroundColor: "white",
                    color: "black",
                  }}
                  onClick={() => handleShipProfileOnExitOrClose()}
                  size={"large"}
                >
                  No, cancel
                </Button>
              </div>
            </Grid2>
            <Grid2 item xs={12} sm={6} md={6} lg={6}>
              <div className="mb-3">
                <Button
                  className="custom-button-save"
                  type="primary"
                  shape="round"
                  onClick={() => {
                    handleShipProfileOnConfirm();
                  }}
                  style={{ fontWeight: "bold", width: "100%" }}
                  size={"large"}
                >
                  Yes, continue
                </Button>
              </div>
            </Grid2>
          </Grid2>
        </>
      </ValidateDeviceProfileModal>
      <ActiveShipDeleteProfile
        modalKey={"deleteprofile"}
        popupName={""}
        customClass={"deleteAlertGroup"}
        popupTitle={"Delete Device Profile"}
        open={hasActiveShipments?.shipValidate?.actionType==="delete"? hasActiveShipments?.activeShipmentPopup?.isOpen: false}
      >
        <>
          <span>This profile cannot be deleted because it is associated with an active shipment. </span><br/>
          <Grid2
            container
            marginTop={2}
            marginBottom={0}
            spacing={1}
            columns={{ xs: 12 }}
          >
             <Grid2 item xs={12} sm={6} md={6} lg={6}>
            </Grid2>
            <Grid2 item xs={12} sm={6} md={6} lg={6}>
              <div className="mb-3">
                <Button
                  className="custom-button-save"
                  type="primary"
                  shape="round"
                  onClick={() => {
                    handleShipProfileOnExitOrClose();
                  }}
                  style={{ fontWeight: "bold", width: "100%" }}
                  size={"large"}
                >
                  Close
                </Button>
              </div>
            </Grid2>
          </Grid2>
        </>
      </ActiveShipDeleteProfile>
      <CreateNewLocation
        isBackButton={true}
        onBackClick={handleBackLocationButtonClick}
      />
    </div>
  );
};

export default DeviceProfile;
